export default __webpack_public_path__ + "static/media/next_arrow.55d3fc67.svg";